import Image from "next/image";
import { carevincoBrand } from "@/shared/config/brand";
import styles from "./CarevincoLogo.module.scss";

type CarevincoLogoProps = {
  header?: boolean;
  priority?: boolean;
};

export function CarevincoLogo({ header = false, priority = false }: CarevincoLogoProps) {
  return (
    <Image
      alt="Carevinco — Your Care, Our Commitment"
      className={`${styles.logo}${header ? ` ${styles.header}` : ""}`}
      height={carevincoBrand.height}
      priority={priority}
      src={carevincoBrand.logo}
      unoptimized
      width={carevincoBrand.width}
    />
  );
}

export function CarevincoMark({ size = 52 }: { size?: number }) {
  return (
    <Image
      alt="Carevinco"
      height={size}
      src={carevincoBrand.mark}
      style={{ display: "block", flex: "0 0 auto", height: size, width: size }}
      unoptimized
      width={size}
    />
  );
}
